import { render } from "./secpassword.vue?vue&type=template&id=1f93745f&scoped=true"
import script from "./secpassword.vue?vue&type=script&lang=js"
export * from "./secpassword.vue?vue&type=script&lang=js"

import "./secpassword.vue?vue&type=style&index=0&id=1f93745f&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f93745f"]])

export default __exports__